<template>
  <div class="outerBox" :style="{ backgroundImage: 'url(' + imgPath + ')' }">
    <div class="maskBox" v-if="prizeFlag == 1"></div>
    <div class="outer_cont">
      <img src="@/assets/image/n1.png" class="img_1" alt="">
      <img src="@/assets/image/n2.png" class="img_2" alt="">
      <div class="outer_one">
        <img src="@/assets/image/n5.png" class="one_1" alt="">
        <div class="one_2">
          <div v-for="(item, index) in prize" :key="index" class="one_2_item">
            <!-- 抽奖活动开始时的遮罩层: 开始抽奖 || 抽奖结束 -->
            <div v-if="index != 4 && index != 8"
              :class="`one_2_item_box ${(prizeFlag === 1 && curIndex === index) || (prizeFlag === 2 && prizeIndex === index) ? 'start_activity' : ''}`">
              <img src="@/assets/image/n4.png" class="one_2_item_1" alt="">
              <div class="one_2_item_2">{{ item.prize_name }}</div>
            </div>
            <div v-if="index == 4" class="one_2_item_box_2" @click="startTap">
              <img src="@/assets/image/n6.png" class="one_2_item_box_2_img" alt="">
              <div class="one_2_item_3">START</div>
            </div>
            <div v-if="index == 8"
              :class="`one_2_item_box ${(prizeFlag === 1 && curIndex === index) || (prizeFlag === 2 && prizeIndex === index) ? 'start_activity' : ''}`">
              <div class="one_2_item_2">{{ item.prize_name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="outer_two">
        <div class="two_1">
          <div class="two_1_one"></div>
          <div class="two_1_two">List Of Winners</div>
          <div class="two_1_one"></div>
        </div>
        <div class="two_2">
          <!-- hover 是否开启鼠标悬停 -->
          <!-- step 步进速度 -->
          <!-- singleHeight 单步运动停止的高度 -->
          <vue-seamless-scroll class="scroll_box" :data="list" :class-option="defineScroll">
            <div v-for="(item, index) in list" :key="index" class="two_2_one">
              <div>{{ item.nickname }}</div>
              <div>₹{{ item.won_money }}</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <!-- <div class="outer_fixed">
      <img src="@/assets/image/logo.png" class="fixed_1" alt="">
      <div class="fixed_2" @click="downLoad">
        <img src="@/assets/image/zc8.png" class="two_1" alt="">
        <div>Android Apk </div>
      </div>
      <div class="fixed_2" @click="redirectToGooglePlay">
        <img src="@/assets/image/zc9.png" class="two_1" alt="">
        <div>Goolgle Play </div>
      </div>
    </div> -->
    <download :isDown="isDown" @mongolia="downLoad"></download>
    <!-- 注册 -->
    <van-popup v-model="registerShow">
      <div class="popup_Box">
        <div class="popup_one settingStyle" :style="'backgroundImage:url(' + require('@/assets/image/biank1.png') + ')'
          ">
          <div class="popup_one_1">
            <img src="@/assets/image/zc2.png" class="popup_one_1_img" alt="">
            <input type="number" v-model="phone" placeholder="Phone Number" class="popup_one_1_input"
              style="max-width: 100%;">
          </div>
          <div class="popup_one_1">
            <img src="@/assets/image/zc3.png" class="popup_one_1_img" alt="">
            <input type="number" v-model="otp" placeholder="OTP" class="popup_one_1_input">
            <div class="popup_one_1_three" @click="obtainClick"> {{ obtain == 0 ? "Send" : obtain }} </div>
            <van-count-down ref="countDown" :time="60 * 1000" format="ss" :autoStart="false" @change="onChange"
              v-show="false">
            </van-count-down>
          </div>
          <div class="popup_one_2" @click="register(1)">Got free ticket</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：注册
 * @author: 刘嘉鑫 
 * @version  V1.0 
 * @datecreate: 2023-11-29 14:16
 */
export default {
  data() {
    return {
      isDown: false, // 下载弹框

      imgPath: require("@/assets/image/bj.jpg"),
      phone: "", // 手机号
      otp: "", // 验证码

      obtain: "Send",
      time: 60,
      timeData: {},

      share_code: "",

      count: 0, // 当前会员剩余抽奖次数
      prize: [], // 奖品列表
      prizeFlag: 0, // 记录抽奖转盘当前的状态； 0：待开始；1-进行中；2-已完成
      prizeIndex: 6,// 记录本次抽奖的奖品下标
      curIndex: -1,// 当前抽奖转盘转动过程中轮询到的九宫格下标
      counts: 8,// 定义转盘抽奖过程中可转的圈数
      timer: "",

      list: [],
      page: 1,

      registerShow: false,

      isRegister: 1, // 1:未注册  2:注册

      choushow:true,//true = 未抽奖中状态    false=抽奖中状态
    };
  },
  //定义计算属性，默认执行一次（监听，类似于data概念）；
  computed: {
    defineScroll() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 43.33, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.share_code = this.$route.query.share_code; //用户id
    sessionStorage.setItem("share_code", this.share_code)

    this.getInfo()
    this.getList()
  },
  methods: {
    /**
     * 奖品列表
     * 刘嘉鑫
     * 2024-1-5
     */
    getInfo() {
      this.$request({
        url: "/Index/drawList",
        data: {},
      }).then((res) => {
        console.log("奖品列表", res)
        this.count = res.data.count
        res.data.list.splice(4, 0, {})
        this.prize = res.data.list
      })
    },

    /**
     * 中奖列表
     * 刘嘉鑫
     * 2024-1-5
     */
    getList() {
      this.$request({
        url: "/Index/drawRunWinningLog",
        data: {
          // page: this.page
        }
      }).then(res => {
        if (res.data.length > 0) {
          this.list = res.data
          // this.list = this.list.concat(res.data)   修改为一次性获取50条2024-6-25
          // this.page = ++this.page
          // if(this.list.length < 60){
          //   this.getList()
          // }else{
          //   console.log('不执行了');
          // }
         
        } else {
          if (this.page > 1) {

          }
        }
      }).catch(function (error) {
        console.log(error)
      })
    },

    /**
     * 抽奖开始
     * 刘嘉鑫
     * 2023-12-28
     */
    startTap() {
      if(this.choushow == false){
        console.log('阻止了抽奖');
        return
      }
      this.choushow = false
      let noLoginPrize = sessionStorage.getItem("Prize") == null ? '' : sessionStorage.getItem("Prize")
      this.getInfo()
      setTimeout(() => {
        if (noLoginPrize == '') {
          if (this.count <= 0) { //没有抽奖次数
            setTimeout(() => {
              this.choushow = true
            },1500)
            this.$dialog.alert({
              message: `Your number of draws has run out. Please download the APP version`,
              confirmButtonText: "Download APP",
              theme: 'round-button',
              confirmButtonColor: "#005D35"
            }).then(() => {
              this.downLoad()
            });
            
            return
          }
          this.$request({
            url: "/Index/drawRunH5",
            data: {},
          }).then((res) => {
            console.log("奖品id", res.data.draw_id)
            if (this.isRegister == 1) { //未注册成功调用
              sessionStorage.setItem("Prize", JSON.stringify(res.data))
            }
            for (let i = 0; i < this.prize.length; i++) {
              // 如果当前元素的ID等于2，则将下标添加到数组中
              if (this.prize[i].id === res.data.draw_id) {
                this.prizeIndex = i
              }
            }

            console.log("开始抽奖")
            // 记录转盘转动结束时要停留的奖品下标
            const pIndex = this.prizeIndex
            this.prizeFlag = 1
            // 记录顺时针转动时奖品的下标集合，剔除掉按钮的下标，
            const array = [0, 1, 2, 5, 8, 7, 6, 3]
            // 记录当前停留的奖品在转盘中的下标，方便设置转动时的样式
            let i = 0
            // 记录转盘转动的圈数
            let counts = 1
            const playRun = () => {
              this.curIndex = array[i++]
              // 最后一圈在选中中奖下标时就停止
              if (counts === this.counts && this.curIndex === pIndex) {
                // 打开奖品预览弹窗
                clearInterval(this.timer)
                // 设置本次抽奖转盘活动为已完成状态
                this.prizeFlag = 2
                if (this.isRegister == 1) {
                  setTimeout(() => {
                    this.$dialog.alert({
                      message: this.prizeIndex == 8 ? `Sorry, you didn't win the prize` : `The prizes drawn: ${this.prize[this.prizeIndex].prize_name}`,
                      confirmButtonText: "Go to Register",
                      theme: 'round-button',
                      confirmButtonColor: "#005D35"
                    }).then(() => {
                      this.$router.push('register?share_code='+this.share_code)
                    });
                  }, 100)
                }
                return
              }
              if (i === 8) {
                // 转盘转完了一圈，继续开始新的一圈
                i = 0
                counts++
              }
              console.log('counts:', counts, this.counts)
              // 设置转盘的速度为： 慢-快-慢
              if (counts > 1 && counts < this.counts - 1) {
                clearInterval(this.timer)
                this.timer = setInterval(playRun, 50)
              } else if (counts === this.counts - 1) {
                clearInterval(this.timer)
                this.timer = setInterval(playRun, 100)
              } else if (counts === this.counts) {
                clearInterval(this.timer)
                this.timer = setInterval(playRun, 150)
              }
            }
            this.timer = setInterval(playRun, 100)
            this.getInfo()
            setTimeout(() => {
              this.choushow = true
            },1500)
          }).catch(error => {
            uni.showToast({
              title: error.msg,
              icon: "none",
              mask: true
            })
            setTimeout(() => {
              this.choushow = true
            },1500)
          })
        } else {
          setTimeout(() => {
              this.choushow = true
            },1500)
          this.$dialog.alert({
            message: 'Your number of draws has been used up, please go to register',
            confirmButtonText: "Go to Register",
            theme: 'round-button',
            confirmButtonColor: "#005D35"
          }).then(() => {
            this.$router.push('register?share_code='+this.share_code)
          });
        }
      }, 500)
    },

    // startTap() {

    //   if (this.isRegister == 1) {
    //     this.registerShow = true
    //   }

    //   if (this.isRegister == 2) {
    //     this.$request({
    //       url: "/Index/drawRun",
    //       data: {},
    //     }).then((res) => {
    //       console.log("奖品id", res.data.id)
    //       for (let i = 0; i < this.prize.length; i++) {
    //         // 如果当前元素的ID等于2，则将下标添加到数组中
    //         if (this.prize[i].id === res.data.id) {
    //           this.prizeIndex = i
    //         }
    //       }

    //       console.log("开始抽奖")
    //       // 记录转盘转动结束时要停留的奖品下标
    //       const pIndex = this.prizeIndex
    //       this.prizeFlag = 1
    //       // 记录顺时针转动时奖品的下标集合，剔除掉按钮的下标，
    //       const array = [0, 1, 2, 5, 8, 7, 6, 3]
    //       // 记录当前停留的奖品在转盘中的下标，方便设置转动时的样式
    //       let i = 0
    //       // 记录转盘转动的圈数
    //       let counts = 1
    //       const playRun = () => {
    //         this.curIndex = array[i++]
    //         // 最后一圈在选中中奖下标时就停止
    //         if (counts === this.counts && this.curIndex === pIndex) {
    //           // 打开奖品预览弹窗
    //           clearInterval(this.timer)
    //           // 设置本次抽奖转盘活动为已完成状态
    //           this.prizeFlag = 2
    //           setTimeout(() => {
    //             this.$dialog.alert({
    //               message: this.prizeIndex == 8 ? `Sorry, you didn't win the prize` : `The prizes drawn: ${this.prize[this.prizeIndex].prize_name}`,
    //               confirmButtonText: "Download APP",
    //               theme: 'round-button',
    //               confirmButtonColor: "#005D35"
    //             }).then(() => {
    //               // on close
    //               this.downLoad()
    //             });
    //           }, 100)
    //           return
    //         }
    //         if (i === 8) {
    //           // 转盘转完了一圈，继续开始新的一圈
    //           i = 0
    //           counts++
    //         }
    //         console.log('counts:', counts, this.counts)
    //         // 设置转盘的速度为： 慢-快-慢
    //         if (counts > 1 && counts < this.counts - 1) {
    //           clearInterval(this.timer)
    //           this.timer = setInterval(playRun, 50)
    //         } else if (counts === this.counts - 1) {
    //           clearInterval(this.timer)
    //           this.timer = setInterval(playRun, 100)
    //         } else if (counts === this.counts) {
    //           clearInterval(this.timer)
    //           this.timer = setInterval(playRun, 150)
    //         }
    //       }
    //       this.timer = setInterval(playRun, 100)
    //     }).catch(error => {
    //       uni.showToast({
    //         title: error.msg,
    //         icon: "none",
    //         mask: true
    //       })
    //     })
    //   }
    // },

    /**
     * 注册
     * 刘嘉鑫
     * 2022-11-26
     */
    register() {
      // this.isRegister = 2
      // this.registerShow = false
      // this.startTap()

      // return
      if (this.phone == "") {
        this.$toast({
          message: "Please enter your phone number",
          duration: 1500,
        });
        return;
      } else if (this.otp == "") {
        this.$toast({
          message: "Please enter the verification code",
          duration: 1500,
        });
        return;
      } else {
        this.$request({
          url: "/Login/h5Register",
          data: {
            mobile: this.phone,
            captcha: this.otp,
            share_code: this.share_code // 邀请码
          },
        }).then((res) => {

          console.log("注册", res.data);
          this.$toast({
            message: res.msg,
            duration: 1500,
          });
          this.isRegister = 2
          localStorage.setItem("token", res.data.userinfo.token)
          this.registerShow = false

          setTimeout(() => {
            // this.startTap()
            let bangding = JSON.parse(sessionStorage.getItem('Prize'))
            this.getjpID(bangding.draw_id)
            sessionStorage.removeItem('Prize')
            console.log('注册成功');
            setTimeout(() => {
              this.getInfo()
            }, 100)
          }, 1500);
        }).catch((error) => {
          this.$toast({
            message: error.msg,
            duration: 1500,
          });
        });
      }
    },

    /**
     * 获取验证码
     * 刘嘉鑫
     * 2022-5-11
     */
    obtainClick() {
      let that = this;
      if (this.phone == "") {
        this.$toast("Please enter your phone number");
        return;
      } else {
        this.$request({
          url: "/Common/sendCode",
          data: {
            mobile: this.phone,
          },
        }).then((res) => {
          console.log(res);
          this.$refs.countDown.start();
        }).catch((error) => {
          this.$toast({
            message: error.msg,
            duration: 1500,
          });
        });
      }
    },

    /**
     * 倒计时
     * 刘嘉鑫
     * 2023-11-29
     */
    onChange(e) {
      this.timeData = e;
      this.obtain = e.seconds;
    },

    /**
    * 下载
    * 刘嘉鑫
    * 2023-11-29
    */
    downLoad() {
      console.log("下载app");
      if (this.$client.QQ == true || this.$client.WEIXIN == true) {
        this.isDown = !this.isDown;
        return;
      } else {
        if (this.$client.ANDROID == true) {
          try {
            window.location.href = "https://keralagame.in/app/KeralaLottery.apk";
            console.log("安卓");
          } catch (e) { }
        }
        if (this.$client.IPHONE == true) {
          try {
            // window.location.href = "https://apps.apple.com/cn/app/随点达/id6451131075";
            console.log("ios");
            return;
          } catch (e) { }
        }
      }
    },

    /**
     * 关闭蒙层
     * 刘嘉鑫
     * 2023-11-29
     */
    mongolia() {
      this.isShow = false;
    },

    redirectToGooglePlay() {

      return
      // 替换下面的 "your_app_package_id" 为你应用的包名（package ID）
      const appPackageId = "";

      // 使用 window.location.href 或者 window.open 来跳转到 Google Play 商店
      window.location.href = `https://play.google.com/store/apps/details?id=${appPackageId}`;
      // 或者
      // window.open(`https://play.google.com/store/apps/details?id=${appPackageId}`, '_blank');
    }
  },
};
</script>
<style lang='scss' scoped>
/deep/ .van-goods-action-button--danger {
  background: linear-gradient(90deg, #005D35 0%, #22B35C 100%) !important;
}

/deep/.van-dialog__button {
  &:first-child {
    .van-button {
      background: linear-gradient(90deg, #005D35 0%, #22B35C 100%) !important;
    }
  }

  &:last-child {
    .van-button {
      background: linear-gradient(90deg, #005D35 0%, #22B35C 100%) !important;
    }
  }
}

.outerBox {
  height: 100%;
  background-size: 100% 100%;
  padding: 0 0 44px;
}

.outer_cont {
  padding-bottom: calc(constant(safe-area-inset-bottom) + 140px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 140px);
  position: relative;
}

.maskBox {
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.img_1 {
  height: 137px;
  margin: 0 43px 0 28px;
}

.img_2 {
  height: 264px;
  margin: 0 auto 0px;
}


.outer_one {
  border-radius: 20px;
  padding: 40px 0 0;
  margin-bottom: 40px;
  position: relative;

  .one_1 {
    width: 287px;
    height: 110px;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  .one_2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 71%;
    margin: 150px auto 0;
    padding-bottom: 70px;

    .one_2_item {
      margin-right: 27px;
      margin-bottom: 30px;
      position: relative;
      border-radius: 12px;
      overflow: hidden;

      .one_2_item_box,
      .one_2_item_box_2 {
        width: 148px;
        height: 148px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
      }

      .one_2_item_box {
        background: #FFFAAB;
        border: 1px solid #AC6500;
        border-radius: 12px;

        .one_2_item_1 {
          width: 46px;
          height: 34px;
          margin-bottom: 20px;
        }

        .one_2_item_2 {
          font-size: 26px;
          font-weight: bold;
          color: #6D0503;
        }
      }

      .one_2_item_box_2 {

        .one_2_item_box_2_img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }

        .one_2_item_3 {
          position: relative;
          font-size: 36px;
          font-weight: bold;
          color: #6D0503;
          line-height: 28px;

          background: linear-gradient(180deg, #FFB400 0%, #FFF100 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }

    .one_2_item:nth-child(3n) {
      margin-right: 0;
    }

    // 抽奖活动开始时的遮罩层
    .start_activity {
      border-image: linear-gradient(180deg, #005D35, #22B35C) 10 10 !important;
      background: linear-gradient(0deg, #005D35 0%, #22B35C 100%) !important;

      .one_2_item_2 {
        color: #FFFCC8 !important;
      }
    }
  }
}

.outer_two {
  background: #005E35;
  border-radius: 60px;
  padding: 40px 28px;
  margin: 0 28px;

  .two_1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;

    .two_1_one {
      width: 80px;
      height: 2px;
      background: linear-gradient(0deg, #FFB400 0%, #FFF100 100%);
    }

    .two_1_two {
      margin: 0 30px;
      font-size: 30px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 60px;
      background: linear-gradient(0deg, #FFB400 0%, #FFF100 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .two_2 {
    background: linear-gradient(180deg, #FFFCD2 0%, #FFFBB0 100%);
    border-radius: 40px;
    padding: 30px 40px 30px;
    height: 500px;
    overflow: hidden;

    .scroll_box {
      height: 100%;
      overflow: hidden;
    }

    .two_2_one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 28px 0;

      div {
        font-size: 26px;
        font-weight: 400;
        color: #8C3607;
      }
    }
  }
}

.outer_fixed {
  padding: 30px 28px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 30px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 30px);
  background: linear-gradient(0deg, #256650 0%, #157F51 100%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: row;

  .fixed_1 {
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    border-radius: 20px;
    margin-right: auto;
    border: 2px solid #ffffff;
  }

  .fixed_2 {
    background: rgba(255, 255, 255, .5);
    border-radius: 100px;
    display: flex;
    align-items: center;
    padding: 20px 30px;
    margin-left: 30px;
    width: 22%;

    img {
      width: 50px;
      height: 50px;
      margin-right: 8px;
    }

    div {
      font-size: 24px;
      font-weight: 400;
      color: #222222;
      text-align: left;
    }
  }
}

.popup_Box {
  width: 90%;
  margin: 0 auto;
}

/deep/ .van-popup {

  background: transparent !important;
}

.popup_one {
  // border: 4px solid #FFB400;
  // background: linear-gradient(135deg, #2BAC69 0%, #22B35C 100%);
  border-radius: 20px;
  padding: 50px;
  margin: 20px;

  .popup_one_1 {
    display: flex;
    align-items: center;
    padding: 32px 60px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%);
    box-shadow: 0px 6px 0px 0px #197A51;
    border-radius: 50px;
    margin-bottom: 44px;

    .popup_one_1_img {
      width: 36px;
      height: 36px;
      margin-right: 30px;
    }

    .popup_one_1_input {
      font-size: 28px;
      font-weight: 400;
      color: #006A3D;
      border: none;
      background: transparent;
      max-width: 66%;
      outline: none;
    }

    .popup_one_1_three {
      font-size: 28px;
      font-weight: bold;
      color: #AE3231;
      margin-left: auto;
      width: 20%;
    }
  }

  .popup_one_2 {
    background: linear-gradient(0deg, #FFB400 0%, #FFF100 100%);
    box-shadow: 0px 6px 0px 0px #784100;
    border-radius: 50px;
    padding: 32px 0;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #006A3D;
  }
}
</style>